import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { _CashFlow } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { MonthConstantsEditor } from "../../../RemoteAbstractAction/editors/MonthConstantsEditor";
import { DropDown } from "../../../theme/Component/DropDown";
import useModal, { MODAL_LG, MODAL_XL } from "../../../theme/Component/hooks/useModal";
import AutoChart from "../../../../core/graph/AutoChart";



export const CashFlow = () => {

    const CashFlow = useDataBean(_CashFlow);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [form, setform] = useState<any>({
        year: _single.getCurrenYear(),
        month: _single.getCurrentMonth()
    })
    const modalGraph = useModal("Grafica", MODAL_XL);
    const [year, setyear] = useState<number>(_single.getCurrenYear())
    const [month, setmonth] = useState<number>(_single.getCurrentMonth())
    const [modalupdate, setModalupdate] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    // useEffect(() => {
    //     getLista();
    // }, [])

    const getLista = () => {

        CashFlow.instance.getCashFlow(year).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }
    const updateCashFlowDataFor = () => {

        CashFlow.instance.updateCashFlowDataFor(form.year, form.month).then(
            (resp: any) => {
                if (resp) {
                    console.log(resp)
                    toast.success('Datos Cargados')
                    setModalupdate({ ...modalupdate, "view": false });
                    getLista()
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const create = () => {
        CashFlow.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const verbyupdate = () => {
        setModalupdate({ ...modalupdate, "view": true });
    }
    const deleteItem = () => {
        CashFlow.deleteItemVoid(CashFlow.bean.IDEntailment).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        CashFlow.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDCashFlow', visible: true },
        { title: 'Tipo', property: 'TypeName', visible: true },
        { title: 'Tipo Movimiento', property: 'MovementTypeName', visible: true },
        { title: 'Tipo Documento', property: 'Mnemonic', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Rubro Presupuestal', property: 'BudgetIDName', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Enero', property: 'Month0Value', visible: true },
        { title: 'Febrero', property: 'Month1Value', visible: true },
        { title: 'Marzo', property: 'Month2Value', visible: true },
        { title: 'Abril', property: 'Month3Value', visible: true },
        { title: 'Mayo', property: 'Month4Value', visible: true },
        { title: 'Junio', property: 'Month5Value', visible: true },
        { title: 'Julio', property: 'Month6Value', visible: true },
        { title: 'Agosto', property: 'Month7Value', visible: true },
        { title: 'Septiembre', property: 'Month8Value', visible: true },
        { title: 'Octubre', property: 'Month9Value', visible: true },
        { title: 'Noviembre', property: 'Month10Value', visible: true },
        { title: 'Diciembre', property: 'Month11Value', visible: true },


    ]
    const actionsDropDown = [
        { id: 1, name: 'Reporte Grafico', permiso: null, activo: true },
    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id === 1) {

                            modalGraph.open();
                        }
                    }}></DropDown>
                </div>
            </div>
        )
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${CashFlow.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Reporte de Flujo de Caja">
            <div className="row">
                <div className="col-md-4">
                    <YearSelector value={year} tittle="Año" onChange={(e) => { setyear(e) }} />
                </div>
                <div className="col-md-2 mt-4 p-2">
                    <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                        Buscar
                    </BasicButton>
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton icon="ri-bar-chart-grouped-fill" clase="btn btn-outline-primary btn-border" eventClick={verbyupdate}>
                        Cargar Datos de Flujo de Caja
                    </BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable headButtons={buttons()} body={lista} head={head} rowSet={CashFlow.setBean} ></BasicTable>
                    <Modal modal={modalupdate} updateModal={setModalupdate} eventModal={updateCashFlowDataFor}>
                        <div className="row">
                            <div className="col-md-6">
                                <YearSelector value={form.year} tittle="Año" onChange={(e: any) => { setform({ ...form, "year": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <MonthConstantsEditor idSelect={form.month} onChange={(e: any) => { setform({ ...form, "month": e }) }} label="Mes" name="" />
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                        <AutoChart data={lista.filter((item)=>item.DataBeanProperties.Type != null)} head={head} useIndexAsXLabel={true}
                            xOptions={['MovementTypeName', 'Mnemonic', 'AccountantIDName', 'BudgetIDName']}
                            yOptions={['Month0Value', 'Month1Value', 'Month2Value', 'Month3Value', 'Month4Value', 'Month5Value', 'Month6Value', 'Month7Value', 'Month8Value', 'Month9Value', 'Month10Value', 'Month11Value']} />

                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {CashFlow.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}